import { Text } from '@thanx/uikit/text'
import Section from 'components/Section'
import { buildTranslate } from 'locales'
import { Fields as Campaign } from 'models/Campaign'
import { VariantOrCampaign } from 'models/CampaignVariant'
import SmsPreview from 'scenes/CampaignCenter/Builder/components/Previews/Sms'
import EmptySection from './EmptySection'

const t = buildTranslate('thanx_campaigns.report.v3.configuration.messages.sms')

type Props = {
  campaign: Campaign
  config: VariantOrCampaign
  className?: string
}

function SmsSection({ campaign, config, className = '' }: Props) {
  // SMS never depended on the branded-app push capability — keep the persisted
  // per-campaign field so historical non-reward SMS keeps rendering.
  const allowNoRedeemSms = campaign.allow_non_reward_messages || config.redeem

  if (!config.notify_sms || !allowNoRedeemSms) {
    return (
      <EmptySection
        title={t('title')}
        description={t('empty')}
        className={className}
      />
    )
  }

  return (
    <Section className={`p-xl ${className}`}>
      <Text.Header4 className="mb-m">{t('title')}</Text.Header4>
      <SmsPreview config={config} />
    </Section>
  )
}

export default SmsSection
